// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__xqfjd","content":"styles_content__3q2Ut","selectAll":"styles_selectAll__3WxyT"};